import React from 'react';
import SelectEscrowOfficer from '../SelectEscrowOfficer/SelectEscrowOfficer';

function telHref(number) {
    const digits = String(number || '').replace(/[^\d+]/g, '');
    return digits ? 'tel:' + digits : null;
}

function Phone({ number }) {
    const href = telHref(number);
    return href
        ? <a className="LoanBids-phone" href={href}>{number}</a>
        : <span className="LoanBids-muted">—</span>;
}

function Email({ address }) {
    return address
        ? <a className="LoanBids-email" href={'mailto:' + address}>{address}</a>
        : <span className="LoanBids-muted" title="No email on file">—</span>;
}

/** Trash can; removing only drops the row from this list, never the vendor record. */
function TrashIcon() {
    return (
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false" fill="currentColor">
            <path d="M14.5 3l1 1H19v2H5V4h3.5l1-1h5zM6 19V7h12v12c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2zm2-10v10h8V9H8z"/>
        </svg>
    );
}

/**
 * One lender on the list, laid out like a Territory row: Lender Contact,
 * Lender, Work, Cell, Email, Remove. Picking a contact fills the rest in, the way
 * Lender follows Lender Contact on the Loan Quotes tab.
 */
export default function LoanBidRow({ row, editable, takenIds, onPick, onRemove }) {
    const lender = row.lender;

    return (
        <div className="LoanBids-row" data-testid="loan-bid-row">
            <div className="LoanBids-cell LoanBids-cell--contact">
                <SelectEscrowOfficer
                    value={lender ? lender.name : ''}
                    vendorType="Lender"
                    contactNoun="contact"
                    companyFilter={lender ? lender.lender : null}
                    storedLeadId={lender ? lender.crm_lead_id : null}
                    disabled={!editable}
                    excludeIds={takenIds}
                    plainField
                    onSelect={(name, companyName, leadId, vendor) => {
                        // A contact without a row id cannot be stored on the list.
                        if (!vendor || !vendor.ARCIMEDES_ROW_ID) return;
                        onPick(row.cid, {
                            vendor_id: String(vendor.ARCIMEDES_ROW_ID),
                            name,
                            lender: companyName || '',
                            work_phone: vendor.WORK_PHONE || null,
                            cell_phone: vendor.PHONE || null,
                            email: vendor.EMAIL_ID || null,
                            crm_lead_id: leadId,
                        });
                    }}
                />
            </div>
            <div className="LoanBids-cell">{lender && lender.lender ? lender.lender : <span className="LoanBids-muted">—</span>}</div>
            <div className="LoanBids-cell"><Phone number={lender && lender.work_phone}/></div>
            <div className="LoanBids-cell"><Phone number={lender && lender.cell_phone}/></div>
            <div className="LoanBids-cell"><Email address={lender && lender.email}/></div>
            <div className="LoanBids-cell LoanBids-cell--action">
                {editable ? (
                    <button
                        type="button"
                        className="LoanBids-remove"
                        aria-label="Remove from list"
                        title="Remove from list"
                        onClick={() => onRemove(row.cid)}
                    >
                        <TrashIcon/>
                    </button>
                ) : null}
            </div>
        </div>
    );
}
